
/**
 * @export
 * @enum {string}
 */
export enum DecimalFormat {
    COMMA = 'COMMA',
    PERIOD = 'PERIOD'
}